import { KeyboardDatePicker } from '@material-ui/pickers';
import styled from 'styled-components';

export const DateFieldStyled = styled(KeyboardDatePicker)`
  border: 1px solid #d1d1d1 !important;
  border-radius: 4px;
  padding-left: 16px !important;
  max-width: 160px;
`;
